'use client';

import Image from 'next/image';
import Button from '@/components/Button';
import { ArrowRightIcon } from '@heroicons/react/20/solid';
import Link from 'next/link';
import { resources, type Resource } from './resources';
import { TypePill } from '@/components/TypePill';

export function BrowseCatalog() {
  return (
    <section className="bg-light-background-100 px-section py-section">
      <div className="max-w-section">
        <div className="flex flex-col items-start justify-center">
          <h3 className="mb-8 max-w-[820px] gradle-gradient-text text-h4">Browse catalog</h3>
        </div>

        <div className="flex justify-center border-t border-gray-4 pt-10">
          <div className="grid grid-cols-1 place-items-center gap-4 md:grid-cols-2 lg:grid-cols-3">
            {resources.map(resource => (
              <ResourceCard key={resource.title} resource={resource} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function ResourceCard({ resource }: { resource: Resource }) {
  return (
    <Link
      href={resource.link}
      key={resource.title}
      className="flex h-[484px] w-full flex-col rounded-3xl bg-white p-4 group md:h-[524px] lg:h-[604px] lg:w-[416px] lg:p-8"
    >
      <div className="relative mb-6 flex h-44 grow-0 items-center justify-center overflow-hidden rounded-xl bg-light-background-200 lg:h-[198px]">
        <Image
          src={resource.image}
          alt={resource.title}
          className={`h-full w-full rounded-xl object-cover transition-transform duration-300 group-hover:scale-110 ${resource.imageHasTitle ? '' : 'brightness-75'}`}
          fill
        />
        {!resource.imageHasTitle && (
          <p className="z-10 max-w-56 text-center text-[14px] font-black text-white md:text-[15px] lg:text-[16px] xl:text-[18px]">
            {resource.title}
          </p>
        )}
      </div>
      <TypePill type={resource.typeLabel} />
      <h2 className="mt-4 mb-2 line-clamp-2 text-h6 text-gray-1">{resource.title}</h2>
      <p className="text-body text-gray-3">{resource.description}</p>
      <Button
        variant="ghost-dark"
        outline={true}
        size="sm"
        className="mt-auto flex w-fit items-center justify-center gap-2 self-end justify-self-end border-gray-5 group-hover:border-transparent group-hover:bg-linear-to-br group-hover:from-primary group-hover:to-secondary group-hover:bg-clip-padding group-hover:text-white"
      >
        Learn more <ArrowRightIcon className="size-5" />
      </Button>
    </Link>
  );
}
